import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private history: string[] = [];

  constructor(private _router: Router) {}

  public startSaveHistory(): void {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.urlAfterRedirects);
      }
    });
  }

  public goBack(defaultBackLink: string = '/'): void {
    this.history.pop();
    const backLink: string | undefined = this.history.pop();

    if (backLink) {
      this._router.navigateByUrl(backLink);
    } else {
      this._router.navigateByUrl(defaultBackLink);
    }
    window.scrollTo({ top: 0 });
  }
}
